export default {
  LIVE: 'L',
  FINISHED: 'F',
  PENDING: 'P',
  DRAFT: 'D'
}
